require("./bootstrap");

import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/inertia-vue3";
import { InertiaProgress } from "@inertiajs/progress";
import { VueReCaptcha } from "vue-recaptcha-v3";
import { store } from "./store";

import MainLayout from "@/components/Layouts/MainLayout";

InertiaProgress.init({
  showSpinner: true,
});

// Setup dark mode
store.commit("setupDarkMode");

createInertiaApp({
  title: (title) => {
    const basename = "Open CDL Jobs";
    if (!title) return basename;
    return `${title} - ${basename}`;
  },
  resolve: (name) => {
    const page = require(`./Pages/${name}`).default;
    page.layout = page.layout || MainLayout;
    return page;
  },
  setup({ el, App, props, plugin }) {
    createApp({
      render: () => h(App, props),
    })
      .use(plugin)
    //   .use(VueReCaptcha, { siteKey: window.siteKey })
      .use(store)
      .mount(el);
  },
});
